import React from "react";
import ReportValue from "./commonTableVal";
import { isNumber } from "underscore";
import { addCommas } from "@domains/utils/numberMethods";
const PivotPoints = (props) => {
    return (React.createElement("div", { className: `pivot-points row px-3 pt-2 ${props.parentClass ? props.parentClass : ""}` }, props.pointPoints.map((ele, idx) => {
        return (React.createElement("div", { className: "col-3 py-3", key: idx },
            React.createElement("div", { className: "pivotName" }, ele.pivotName),
            !!ele.pivotValue ? (React.createElement("div", { className: "pivotValue" }, isNumber(ele.pivotValue) ? (React.createElement(ReportValue, { val: addCommas(ele.pivotValue), stream: false, onlyval: false, maximumFractionDigits: 4 })) : (React.createElement(React.Fragment, null,
                " ",
                ele.pivotValue !== "NA"
                    ? addCommas(Number(ele.pivotValue), false, "", 4)
                    : "NA")))) : ("-"),
            !!ele.pivotDate && (React.createElement("div", { className: "pivotDate txt_primaryGrey DMsanR_10_400 textOverflow-max100", title: ele.pivotDate }, ele.pivotDate))));
    })));
};
export default PivotPoints;
